// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"9fbfaeb0","605":"0a5f6e40","809":"62452d41","981":"3467f65a"}[chunkId] + ".chunk.js";
};